import React, { useState, useEffect } from "react";
import { Rating } from "@mui/material";
import { doc, setDoc, collection, getDocs, getDoc } from "firebase/firestore";
import { firestore } from "../config/db"; // Adjust the import path to your Firebase config

const RatingComponent = ({ uid, setFeedbackList }) => {
  const [defaultRating, setDefaultRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const userDocRef = doc(firestore, `submissions/${uid}`);
        const feedbackCollectionRef = collection(userDocRef, "feedback");
        const querySnapshot = await getDocs(feedbackCollectionRef);

        const feedbackData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setFeedbackList(feedbackData); // Pass feedback data to parent component
      } catch (err) {
        console.error("Error fetching feedback: ", err);
        setError("Nie udało się pobrać komentarzy.");
      }
    };

    const fetchRating = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const adminId = user.uid;

        const userDocRef = doc(firestore, `submissions/${uid}`);
        const ratingCollectionRef = collection(userDocRef, "rating");

        const ratingDocRef = doc(ratingCollectionRef, adminId);
        const docSnapshot = await getDoc(ratingDocRef);

        if (docSnapshot.exists()) {
          let ratingDocData = docSnapshot.data();
          setDefaultRating(ratingDocData.rating); // Set the rating fetched from Firestore
        } else {
          console.log("No such document!");
          setDefaultRating(0)
        }
      } catch (err) {
        console.error("Error fetching rating: ", err);
        setError("Nie udało się pobrać ocen.");
      }
    };

    fetchFeedback();
    fetchRating();
  }, [uid, setFeedbackList]);

  const updateRating = async (newRating) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const adminId = user.uid;
      const adminEmail = user.email;

      const userDocRef = doc(firestore, `submissions/${uid}`);
      const ratingCollectionRef = collection(userDocRef, "rating");
      const ratingDocRef = doc(ratingCollectionRef, adminId); // Use adminID as rating document ID

      await setDoc(ratingDocRef, {
        rating: newRating,
        adminId,
        adminEmail,
        timestamp: new Date(),
      });

      console.log("Document successfully written with admin UID!");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <Rating
        name="size-large"
        value={defaultRating}
        size="large"
        max={10}
        onChange={(event, newValue) => {
          setDefaultRating(newValue); // Update local state when rating changes
          updateRating(newValue);     // Update the rating in Firestore
        }}
        className="custom-rating"
      />
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default RatingComponent;
